import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=4308bb7e&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"
import style0 from "./productList.vue?vue&type=style&index=0&id=4308bb7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308bb7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4308bb7e')) {
      api.createRecord('4308bb7e', component.options)
    } else {
      api.reload('4308bb7e', component.options)
    }
    module.hot.accept("./productList.vue?vue&type=template&id=4308bb7e&scoped=true", function () {
      api.rerender('4308bb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/productList.vue"
export default component.exports